export const Pathname = {
  home: '/',
  referral: '/referral',
  choose: '/choose',
  promotion: '/promotion',
  plans: '/plans',
  innerpage: '/innerpage',
  purchasePlans: '/plans/:type/:id',
  purchasePlan: (type, id) => `/plans/${type}/${id}`,
  gettingStarted: '/getting-started',
  profile: {
    basePath: '/profile',
    friendProfile: '/:profileID',
  },
  getFriendProfilePath: (profileID) => `/profile${profileID !== undefined ? `/${profileID}` : ''}`,
  getFriendSearch: (profileID) => `/search${profileID !== undefined ? `/${profileID}` : ''}`,
  getFriendWatchList: (profileID) => `/watchlist${profileID !== undefined ? `/${profileID}` : ''}`,
  getProfilePath: () => '/profile',
  watchlist: {
    basePath: '/watchlist',
    friendProfile: '/:profileID',
  },
  search: {
    basePath: '/search',
    friendProfile: '/:profileID',
  },
  access: '/access',
  dashboard: '/dashboard',
  quickUserUpload: '/quick-user-upload',
  contribute: '/contribute',

  storage: {
    basePath: '/storage',
    cloud: '/cloud',
    videos: '/videos',
    photos: '/photos',
  },
  getStoragePath: (path) => `/storage${path}`,

  video: '/video/:videoID',
  album: '/album/:albumID',
  getVideoPath: (id) => `/video/${id}`,
  getAlbumPath: (id) => `/album/${id}`,
  player: '/player/:videoID/:type',
  albumPlayer: '/albumplayer/:albumID/photo/:photoId',
  getPlayerPath: (id, type) => `/player/${id}/${type}`,
  getAlbumPlayerPath: (id, photo_id) => `/albumplayer/${id}/photo/${photo_id}`,
  yourVideos: '/your-videos',
  contentLayout: '/content-layout',
  contentLayoutDashboard: '/content-layout/:layoutType/:id',
  contentYourVideosDashboard: '/your-videos/:layoutType/:id',
  getContentLayoutPath: (layoutType, id) => `/content-layout/${layoutType}/${id}`,
  getYourVideoLayoutPath: (layoutType, id) => `/your-videos/${layoutType}/${id}`,
  contentLayoutType: '/content-layout/:layoutType',
  getContentLayoutType: (layoutType) => `/content-layout/${layoutType}`,
  settings: {
    basePath: '/settings',
    accounts: '/accounts',
    notifications: '/notifications',
    privacy: '/privacy',
    manageUsers: '/manage-users',
    referrals: '/referrals',
    affiliate: '/affiliate',
    billings: '/billings-and-payments',
    managePaymentMethods: '/manage-payment-methods',
    termsAndConditions: '/terms-of-use',
    subscriberAgreement: '/subscriber-agreement',
    cloud: '/cloud',
  },
  getSettingsPath: (path) => `/settings${path}`,
  viewers: {
    basePath: '/viewers',
    viewer: '/viewerlists',
    groups: '/groups',
    successors: '/successors',
  },
  getViewersPath: (path) => `/viewers${path}`,

  projectorStream: '/',
  terms: '/',
  userRights: '/',
  about: '/',
  projectorStreamPartnerProgram: '/',

  giftFlow: {
    intro: '/gift/:affId?',
    receiving: '/receiving-gift',
    payment: '/gift-payment',
    content: '/gift-content',
  },

  mobileCamera: '/mobile-camera/:sessionId',

  // Interview-record feature: new user can invite someone to a 1-to-1
  // recorded conversation right after avatar. WebRTC P2P call signaled
  // by the Django microservice (see src/Api/roomsApi.js). Host owns the
  // recording; final clip flows through the existing gift upload pipeline.
  interview: {
    intro: '/interview/intro',
    host: '/interview/host',
    join: '/interview/join/:roomId',
    review: '/interview/review',
  },
  getInterviewJoinPath: (roomId) => `/interview/join/${roomId}`,

  authentication: {
    verifyUsingLink: 'auto-verify',
    autoLogin: '/autoLogin',
    avatar: '/avatar',
    chooseOccasion: '/choose-occasion',
    toTrail: '/welcome',
    quickUserWelcome: '/quick-user-welcome',
    quickUserPayment: '/quick-user-payment',
    invite: '/inviteuser',
    ecosystem: '/ecosystem',
    signOut: '#',
    signUp: '/sign-up',
    newSignUp: '/newSign-Up',
    signUp_refferedBy: '/sign-up/:refferedBy',
    signIn: '/newSign-in',
    newsignIn: '/newSign-in',
    forgotPassword: '/forgot-password',
    setPassword: '/setpassword',
    verifyEmail: '/verify-email',
    verifyEmailLink: '/verify-your-email',
    verifyEmailFallback: '/verify-email-fallback',
    mobileVerification: '/mobile-verification',
    newmobileVerification: '/newMobile-verification',
    verifyCode: '/verify-code',
    newverifyCode: '/newVerification-code',
    newverifyCodeEmail: '/email-verification',
  },

  updateGroup: '?updateGroup',
  updatingGroup: (id, title) => `?updateGroup?${id}?${title}`,
  requestAccess: '?request-access',
  grantAccess: '?grant-access',
  createGroup: '?create-group',
  addSuccessor: '?add-successor',
  uploadVideo: '?upload-video',
  checkout: '?checkout',
  cancelSubscription: '?cancel-subscription',
  projectorTermsAndServices: '/terms-and-services',
  termsAndConditions: '/terms-of-use',
  privacy: '/privacy',
  manageDevice: '/manage-device',
  tvLogin: '/tv-login',
  autoTVLogin: '/autoTVLogin',
  referFriend: '?refer-friend',
  upgradePlan: '?upgrade-plan',
  processingInBackGround: '?processing-in-background',
  shortLink: '/shrt/:key',
  mobileUpload: '/mobile-upload',
  contributeMobileUpload: '/contribute-mobile-upload',
};
